<app-boolean-field [view]="view" *ngIf="type === 'boolean'"
    [field]="field" (fieldChange)="fieldChange.emit($event)"></app-boolean-field>

<app-number-field [view]="view" *ngIf="type === 'number'"
    [field]="field" (fieldChange)="fieldChange.emit($event)"></app-number-field>

<app-date-field [view]="view" *ngIf="type === 'date'"
    [field]="field" (fieldChange)="fieldChange.emit($event)"></app-date-field>

<app-text-field [view]="view" *ngIf="type === 'text'"
    [field]="field" (fieldChange)="fieldChange.emit($event)"></app-text-field>

<app-long-text-field [view]="view" *ngIf="type === 'long-text'"
    [field]="field" (fieldChange)="fieldChange.emit($event)"></app-long-text-field>

<app-list-field [view]="view" *ngIf="type === 'list'"
    [field]="field" (fieldChange)="fieldChange.emit($event)"></app-list-field>
